import axios from "axios";
let adminUrl = "https://wtsacademy.dedicateddevelopers.us/api/";
if (process.env?.REACT_APP_ENV === "production") {
  adminUrl = "https://wtsacademy.dedicateddevelopers.us/api/"; 
}


let imageURl = "https://wtsacademy.dedicateddevelopers.us/uploads/product";

export const baseURL = adminUrl;
let axiosInstance = axios.create({ baseURL });

axiosInstance.interceptors.request.use(
  async function (config) {
    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token");
    if (token !== null || token !== undefined) {
      config.headers["x-access-token"] = token;
    }

    return config;
  },
  function (err) {
    return Promise.reject(err);
  }
);

export const productImagePath = (media) => {
  

  return imageURl + `/${media}`;
};

export default axiosInstance;
